export default "__VITE_ASSET__ec932559__"